import { useTranslation } from '@frontend/i18n';
import { shell } from '@frontend/shell-utils';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text, Heading, Button } from '@frontend/design-system';
import { useInsuranceTabShallowStore } from '../stores/use-insurance-tab-store';

interface SwitchToLargeModalProps extends ModalControlModalProps {
  onViewReport: () => void;
}

export const SwitchToLargeModal = ({ onViewReport, ...modalProps }: SwitchToLargeModalProps) => {
  const { t } = useTranslation();
  const { setShouldReportOpenInLargeModeSwitch } = useInsuranceTabShallowStore(
    'setShouldReportOpenInLargeModeSwitch',
    'shouldReportOpenInLargeModeSwitch'
  );

  return (
    <Modal {...modalProps} maxWidth={360}>
      <Modal.Header onClose={modalProps.onClose}>
        <Heading level={2}>{t('Eligibility Report Available in Large Mode Only')}</Heading>
      </Modal.Header>
      <Modal.Body>
        <Text>
          {t(
            'The eligibility report is designed for larger screens to ensure optimal readability and interaction. Switch to large mode to view the detailed eligibility report.'
          )}
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant='primary'
          css={{ width: theme.spacing(24), marginLeft: 'auto' }}
          onClick={() => {
            modalProps.onClose();
            shell?.invoke?.('main:update-options', { width: 1500 });
            setShouldReportOpenInLargeModeSwitch(true);
          }}
        >
          {t('Switch to Large Mode')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
